{
    "columns": [
      {
        "header_id": "clientAuth",
        "header_label": "Spending Plan",
        "jsonpath": "clientAuth",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "consumerFirstName",
        "header_label": "First Name",
        "jsonpath": "consumerFirstName",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "consumerLastName",
        "header_label": "Last Name",
        "jsonpath": "consumerLastName",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "medicaid",
        "header_label": "UCI ID",
        "jsonpath": "medicaid",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "consumerPPLId",
        "header_label": "Participant PPL ID",
        "jsonpath": "consumerPPLId",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "codeDesc",
        "header_label": "Service Code",
        "jsonpath": "codeDesc",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "serviceDescription",
        "header_label": "Service Description",
        "jsonpath": "serviceDescription",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y",
        "textTruncateMinLimit": "50ch"
      },
      {
        "header_id": "providerPPLIds",
        "header_label": "Provider",
        "jsonpath": "providerPPLIds",
        "isDisplayedAtHeader": "y",
        "isSearchable": "n"
      },
      {
        "header_id": "estimatedMidWeekUnits",
        "header_label": "Calc. Weekly Hrs",
        "jsonpath": "estimatedMidWeekUnits",
        "isDisplayedAtHeader": "n",
        "isSearchable": "n"
      },
      {
        "header_id": "units",
        "header_label": "Authorized Dollars",
        "jsonpath": "units",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "usedUnits",
        "header_label": "Spent Dollars",
        "jsonpath": "usedUnits",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "remainingDollars",
        "header_label": "Remaining Dollars",
        "jsonpath": "remainingDollars",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "serviceCoordinator",
        "header_label": "Service Coordinator",
        "jsonpath": "serviceCoordinator",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "providerPPLIds",
        "header_label": "Providers",
        "jsonpath": "providerPPLIds",
        "isDisplayedAtHeader": "N",
        "isSearchable": "y"
      },
      {
        "header_id": "startDate",
        "header_label": "Auth Start Date",
        "jsonpath": "startDate",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "endDate",
        "header_label": "Auth End Date",
        "jsonpath": "endDate",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "sourceValue",
        "header_label": "Source",
        "jsonpath": "sourceValue",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "orgName",
        "header_label": "Regional Center",
        "jsonpath": "orgName",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "statusLkp",
        "header_label": "Status",
        "jsonpath": "statusLkp",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      },
      {
        "header_id": "isDeleted",
        "header_label": "Deactivated",
        "jsonpath": "isDeleted",
        "isDisplayedAtHeader": "y",
        "isSearchable": "y"
      }
    ],
    "buttons": [
      {
        "button_id":"Approve",
        "button_label":"Approve",
        "buttonAction" : "approve",
        "className": "primary-btn-color"
      },
      {
        "button_id":"Deny",
        "button_label":"Deny",
        "buttonAction" : "Deny",
        "className": "primary-btn-color"
      },
      {
        "button_id":"Clone",
        "button_label":"Clone",
        "buttonAction" : "Clone",
        "className": "primary-btn-color"
      }
    ],
    "apiDetails": "authorizationsList.json",
    "pageName": "consumer-auth",
    "orderByColumn": ["modifiedDate"],
    "orderBy": ["desc"]
  }
  